import React, { useCallback } from 'react';
import styles from './Footer.module.scss';
import { Container, Row, Col } from 'react-grid-system';
import Image from 'next/image';
import { Text, IconPlace, IconPhone, IconWhats } from 'condolivre-ds';
import { usePartner } from '../../providers/Partner';

const Footer = () => {
	const { name, footer } = usePartner();

	const handleOpenSupport = useCallback(() => {
		const newWindow = window.open(
			`https://api.whatsapp.com/send?phone=${footer?.whatsapp_phone}`,
			'_blank',
			'noopener,noreferrer',
		);
		if (newWindow) {
			newWindow.opener = null;
		}
	}, [footer]);

	return (
		<div
			className={styles.footerContainer}
			style={{
				background: footer?.colors?.background,
				borderBottomColor: footer?.colors?.containerBorderBottom,
			}}
			data-type="restrain-style">
			<Container className={styles.container}>
				<Row>
					<Col
						className={styles.footerText}
						style={{
							borderBottomColor: footer?.colors?.footerTextBorderBottom,
						}}>
						<Image
							src={footer?.logo?.standard}
							width={footer?.logo?.width}
							height={footer?.logo?.height}
							alt={name?.standard}
						/>
						<Text size="v_16" weight="v_500" color={footer?.colors?.text}>
							{footer?.text}
							<br />
							{footer?.cnpj}
						</Text>
						{footer?.links?.visible ? (
							<Text size="v_16" weight="v_500" color={footer?.colors?.text}>
								<a
									className={styles.anchorStyle}
									href={footer?.links?.terms}
									target="blank">
									Termos e Condições de Uso
								</a>{' '}
								|{' '}
								<a
									className={styles.anchorStyle}
									href={footer?.links?.privacy}
									target="blank">
									Aviso de Privacidade
								</a>
							</Text>
						) : null}
					</Col>
				</Row>
				<Row>
					<Col lg={4} className={styles.left}>
						<Text weight="v_500" color={footer?.colors?.subtitle} size="v_16">
							Nosso endereço
						</Text>
						<Text
							size="v_14"
							weight="v_500"
							className={styles.tip}
							color={footer?.colors?.contact}>
							<IconPlace />
							<div>
								{footer?.address?.line_one} <br />
								{footer?.address?.line_two}
							</div>
						</Text>
					</Col>
					<Col lg={4} className={styles.center}>
						<Text weight="v_500" color={footer?.colors?.subtitle} size="v_16">
							Central de atendimento
						</Text>
						<Text
							size="v_24"
							weight="v_600"
							className={styles.tip}
							color={footer?.colors?.contact}>
							<IconPhone />
							<div>{footer?.call_center_phone}</div>
						</Text>
					</Col>
					<Col lg={4} className={styles.right} onClick={handleOpenSupport}>
						<Text weight="v_500" color={footer?.colors?.subtitle} size="v_16">
							Equipe de suporte
						</Text>
						<Text
							size="v_24"
							weight="v_600"
							className={styles.tip}
							color={footer?.colors?.contact}>
							<IconWhats />
							<div>{footer?.support_phone}</div>
						</Text>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default Footer;
